import { createFederatedAccessProvider } from './federatedAccessProvider';
import { createLocalAccessProvider } from './localAccessProvider';
import type { AccessProvider } from './types';

export type { AccessProvider, Principal } from './types';
export { AccessConfigurationError } from './types';
export { PlatformRole, isPlatformRole } from './roles';
export { useCanManageAccess } from './useCanManageAccess';
export { RequireAccessManagement } from './RequireAccessManagement';
export type { PlatformRole as PlatformRoleValue } from './roles';

function selectAccessProvider(): AccessProvider {
  const selected = import.meta.env.VITE_ACCESS_PROVIDER ?? 'local';
  switch (selected) {
    case 'local':
      return createLocalAccessProvider();
    case 'federated':
      return createFederatedAccessProvider();
    default:
      throw new Error(`Proveedor de acceso desconocido: "${selected}".`);
  }
}

/**
 * The single access-provider instance the whole application depends on.
 * Every consumer imports this, never a concrete provider — see the seam
 * documented in `src/access/types.ts`.
 */
export const accessProvider: AccessProvider = selectAccessProvider();
